import React from 'react';
import { SelectInput } from '../../Form/SelectInput';

var Input = function Input(props) {
  return /*#__PURE__*/React.createElement(SelectInput, {
    className: props.className,
    disabled: props.loading || props.disabled,
    error: props.errors[props.name],
    errorText: props.errors[props.name] || 'This field is required',
    hasHiddenLabel: props.hasHiddenLabel,
    id: props.name,
    label: props.label,
    name: props.name,
    placeholder: props.placeholder ? props.placeholder : 'Choose one',
    onChange: props.handleSelectChange,
    options: props.options,
    position: props.position,
    value: props.values[props.name],
    useNative: props.useNative,
    testId: props.testId
  });
};

export { Input };